import React, { memo, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { map } from 'lodash'
import { ContentSectionBlock, DetailList } from 'camino-react'

import { booleanToText } from './utilities'
import { cloudhelpGet } from 'Utilities/CloudHelp'

const MicrosoftManagement = memo(({ customerContract }) => {
  const [cspProducts, updateCSPProducts] = useState([
    { name: 'No managed 365 services.' }
  ])

  useEffect(() => {
    cloudhelpGet(`/api/contracts/${customerContract.id}/services`)
      .then(({ data }) => {
        updateCSPProducts(data)
      })
  }, [])

  return (
    <ContentSectionBlock title='Contracted Services'>
      <DetailList
        list={[
          {
            title: 'Managed',
            content: booleanToText(customerContract.managed)
          },
          {
            title: 'Managed Services',
            content: map(cspProducts, 'name').join(', ')
          },
          { title: 'Backup', content: booleanToText(customerContract.backup) },
          {
            title: 'Mail Scanning',
            content: booleanToText(customerContract.managed_mailscanning)
          }
        ]}
      />
    </ContentSectionBlock>
  )
})

MicrosoftManagement.propTypes = {
  customerContract: PropTypes.shape({
    client_id: PropTypes.number.isRequired,
    managed: PropTypes.bool.isRequired,
    backup: PropTypes.bool.isRequired,
    managed_mailscanning: PropTypes.bool.isRequired,
    csp_service_ids: PropTypes.arrayOf(PropTypes.number).isRequired
  }).isRequired
}

export default MicrosoftManagement
